import { m } from "framer-motion";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import RotateBox from "../../Components/RotateBox/RotateBox";
import { fadeIn } from "../../Functions/GlobalAnimations";
import { getTeam } from "../../Store/Publication/team";
import { useQuery } from "@tanstack/react-query";
import Loading from "../../Components/Loading";
import { useLocation } from "react-router-dom";

const Management = () => {
  const [activeButton, setActiveButton] = useState("SPMU");
  const [filterData, setFilterData] = useState([]);
  const organogramButtons = [
    "SPMU",
    "RPMU Kottayam",
    "RPMU Thrissur",
    "RPMU Kannur",
    "PIU KAU",
    "PIU Industries",
    "PIU KSUM",
    "PIU KINFRA",
  ];

  const location = useLocation();

  // Sample team data - replace with your actual data
  const { data: teamData, isLoading: isLoadingTeam } = useQuery({
    queryKey: ["teamData"],
    queryFn: () => getTeam(),
    refetchOnWindowFocus: false,
    refetchOnMount: true,
  });

  useEffect(() => {
    if (location.state) {
      setActiveButton(location?.state);
    }
  }, [location?.state]);

  useEffect(() => {
    if (teamData?.data?.length > 0) {
      const findBranch = teamData.data.filter(
        (ele) =>
          ele?.branch === activeButton &&
          Number(ele?.rank) >= 1 &&
          Number(ele?.rank) <= 20
      );

      // Optional: sort by rank if needed
      const sortedByRank = findBranch.sort(
        (a, b) => Number(a.rank) - Number(b.rank)
      );

      setFilterData(sortedByRank);
    }
  }, [teamData, activeButton]);

  if (isLoadingTeam) return <Loading />;
  return (
    <m.div
      className="container mt-[200px]"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <Col xl={8} lg={10} className="text-center w-fit">
        <h3 className="font-serif text-[30px] mb-[2px]  font-medium text-[#146084] -tracking-[1px]">
          Team
        </h3>
        <m.div
          className="border-b border-1 w-[40%] border-[#146084]"
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        />
      </Col>

      <div className="flex flex-wrap sm:flex-col relative">
        {organogramButtons.map((btn, index) => (
          <div
            key={index}
            className={`p-[10px] px-[20px]  mt-[30px] relative ${
              activeButton === btn ? "text-[#146084]" : "text-black"
            }`}
          >
            <button
              onClick={() => {
                setActiveButton(btn);
              }}
              className="bg-transparent border-none sm:text-[15px] text-[17px] relative z-10"
            >
              {btn}
            </button>

            {/* Animated underline */}
            {activeButton === btn && (
              <m.div
                className="absolute bottom-0 left-0 h-[2px] bg-[#146084] w-full"
                layoutId="activeTab"
                transition={{
                  type: "spring",
                  bounce: 0.2,
                  duration: 0.6,
                }}
              />
            )}
          </div>
        ))}
      </div>

      {/* Content area with rotating cards */}
      <m.div
        key={activeButton}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        className="mt-8 p-4"
      >
        <Row className="row-gap-5">
          <Col xs={12} sm={8} md={12}>
            <RotateBox
              data={filterData}
              grid="row-cols-1 row-cols-md-3 row-cols-lg-4 gap-y-10 justify-center"
              animation={fadeIn}
            />
          </Col>
        </Row>
      </m.div>
    </m.div>
  );
};

export default Management;
